import { render, staticRenderFns } from "./customTab.vue?vue&type=template&id=e99fd4c0&scoped=true"
import script from "./customTab.vue?vue&type=script&lang=js"
export * from "./customTab.vue?vue&type=script&lang=js"
import style0 from "./customTab.vue?vue&type=style&index=0&id=e99fd4c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e99fd4c0",
  null
  
)

export default component.exports